var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{staticClass:"form-control ml-2",attrs:{"type":"text","placeholder":_vm.placeHolder},on:{"update":_vm.updated},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }